import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { LocationDetailSaveModel } from '../../location-details/models/location-detail-save.model';

export const addLocation = createAction('[Add Location] Add Location');

export const createLocation = createAction(
   '[Create Location] Create Location',
   props<{ location: LocationDetailSaveModel }>()
);

export const createLocationAndAddAnother = createAction(
   '[Create Location] Create Location and Add Another',
   props<{ location: LocationDetailSaveModel }>()
);

export const createLocationAndAddAnotherSuccess = createAction(
   '[Add Location] Create Location and Add Another Success',
   props<{ locationId: number }>()
);

export const createLocationSuccess = createAction(
   '[Add Location] Create Location Success',
   props<{ locationId: number }>()
);

export const createLocationFailure = createAction('[API] Create Location Failure', props<SingleGraphError>());

export const createLocationAndAddAnotherFailure = createAction(
   '[API] Create Location and Add Another Failure',
   props<SingleGraphError>()
);
